// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../config/styles';

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
  },
  paymentForm: {
    width: '70%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingBottom: 24,
    maxWidth: 450,
    [theme.breakpoints.down(700)]: {
      width: '80%',
    },
    [theme.breakpoints.down(600)]: {
      width: '90%',
    },
  },
  paypalContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px 0',
  },
  buttonStyle: {
    marginRight: 20,
    border: '1px solid rgb(200, 200, 200)',
    background: 'none',
    borderRadius: 7,
    [theme.breakpoints.down(500)]: {
      marginRight: 5,
      marginLeft: 0,
    },
    '&:hover': {
      boxShadow: `${GlobalStyles.color.COLOR_SHADOW} !important`,
      backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    },
  },
  selected: {
    boxShadow: '0 0 10px rgba(0,0,0, 0.2) !important',
    border: `1px solid ${GlobalStyles.color.COLOR_SECONDARY} !important`,
  },
  noteText: {
    maxWidth: 400,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GREY,
  },
  noteTextBold: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  secureTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  marginLeft: {
    marginLeft: 5,
  },
  submitButtonStyle: {
    margin: '15px auto',
  },
  paypalImage: {
    width: 150,
  },
  paypalButton: {
    margin: 0,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    padding: 0,
    border: '1px solid rgb(200, 200, 200)',
    borderRadius: 7,
    overflow: 'hidden',
    height: 38,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      boxShadow: `${GlobalStyles.color.COLOR_SHADOW} !important`,
    },
    '&:focus': {
      outline: 0,
    }
  },
  secureImage: {
    width: 15,
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  successText: {
    color: GlobalStyles.color.COLOR_GREEN,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
  },
  rejectedColor: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  paymentTypeContainer: {
    marginTop: 20,
  },
});

export default styles;
